import React, {useState, useEffect, ReactNode} from 'react'

import {FadeInWrapper} from './styles'

type FadeInProps = {
  children: ReactNode
}

const FadeIn: React.FC<FadeInProps> = ({children}) => {
  const [visible, setVisible] = useState(false)
  useEffect(() => {
    const frame = requestAnimationFrame(() => {
      setVisible(true)
    })
    return () => cancelAnimationFrame(frame)
  }, [])
  return <FadeInWrapper visible={visible}>{children}</FadeInWrapper>
}

export default FadeIn
